
const cache = {
  state: {
    cacheViews: [],//缓存页面
  },

  mutations: {
    SET_CACHE: (state, data) => {
      state.cacheViews = data
    },
  },

  actions: {
    set_cache({ commit }, data) {
      commit('SET_CACHE', data)
    },
  }
}

export default cache



// WEBPACK FOOTER //
// ./src/store/modules/cache.js